// import { isLegacyEndUserOnboardingAtom } from 'atoms/isLegacyEndUserOnboardingAtom';
// import { useAtomValue } from 'jotai';
import { useContext } from 'react';

import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { SpecialistContext } from 'context';

import { TabListProps } from './types';

import * as S from './styles';

export const TabList: React.FC<TabListProps> = ({ selectedIndex }) => {
  const { id } = useParams<{ id: string }>();
  const { specialistInfo } = useContext(SpecialistContext);
  // const isPreAssessmentV1 = useAtomValue(isLegacyEndUserOnboardingAtom);

  return (
    <S.TabMenu selectedIndex={selectedIndex}>
      <S.TabItem>
        <Link to={`/enduser/${id}`}>
          <FormattedMessage id="TABLIST.OVERVIEW" />
        </Link>
      </S.TabItem>

      {/* TODO:
        NEW ONBOARDING
        Remove the feature flag (isLegacy)
        and the structures related to the old onboarding
        when the experiment is finished
      */}
      <S.TabItem>
        <Link to={`/enduser/${id}/pre-assessment`}>
          <FormattedMessage id="TABLIST.PREASSESSMENT" />
        </Link>
      </S.TabItem>
      <S.TabItem>
        <Link to={`/enduser/${id}/clinical-assessment`}>
          <FormattedMessage id="TABLIST.CLINICALASSESSMENT" />
        </Link>
      </S.TabItem>
      {specialistInfo?.geoCode === 'BR' && (
        <S.TabItem>
          <Link to={`/enduser/${id}/activities`}>
            <FormattedMessage id="TABLIST.ASSESSMENT" />
          </Link>
        </S.TabItem>
      )}
    </S.TabMenu>
  );
};
